export default (word, capitalise) => {
  if (!word || typeof (word) !== 'string') {
    return word;
  }
  const defaultArticle = capitalise ? 'A' : 'a';
  return /^[aeiouAEIOU]/.test(word[0]) ? `${defaultArticle}n ${word}` : `${defaultArticle} ${word}`;
};
